export const mockNotificationLawyerTime = () => [
  { value: "", label: "Sem notificar" },
  { value: "1-d", label: "1 dia antes" },
  { value: "2-d", label: "2 dias antes" },
  { value: "3-d", label: "3 dias antes" },
  { value: "4-d", label: "4 dias antes" },
  { value: "5-d", label: "5 dias antes" },
  { value: "1-w", label: "1 semana antes" },
];
